<template>
  <v-dialog v-model="dialog" scrollable width="750">
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title>Thông tin chi tiết thiết bị</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6">
        <v-row dense class="mb-3">
          <v-col cols="12" md="6">
            <span class="grey--text">Mã thiết bị / Barcode:</span>
            <strong class="primary--text ml-2">{{ item.code }}</strong>
          </v-col>
          <v-col cols="12" md="6">
            <span class="grey--text">Trạng thái:</span>
            <v-chip x-small :color="item.status | assetStatusColor" dark class="ml-2">
              {{ item.status | assetStatus }}
            </v-chip>
          </v-col>

          <v-col cols="12">
            <span class="grey--text">Tên thiết bị:</span>
            <strong class="text-subtitle-1 ml-2">{{ item.name }}</strong>
          </v-col>

          <v-col cols="12" md="6">
            <span class="grey--text">Đầu mục:</span>
            <span class="ml-2 font-weight-medium">{{ get(item, 'category.name', '-') }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span class="grey--text">Vị trí / Khu vực:</span>
            <span class="ml-2 font-weight-medium">{{ get(item, 'location.name', '-') }}</span>
          </v-col>

          <v-col cols="12" md="6">
            <span class="grey--text">Cấp học áp dụng:</span>
            <span class="ml-2 font-weight-medium">
              {{ get(item, 'academicLevel.title', get(item, 'academicLevel.name', '-')) }}
            </span>
          </v-col>
          <v-col cols="12" md="6">
            <span class="grey--text">Số lượng:</span>
            <span class="ml-2">
              Khả dụng <strong class="success--text">{{ item.availableQuantity }}</strong> / Tổng <strong>{{ item.quantity }}</strong> {{ item.unit || 'Chiếc' }}
            </span>
          </v-col>

          <v-col cols="12" md="6">
            <span class="grey--text">Ngày mua sắm:</span>
            <span class="ml-2 font-weight-medium">{{ item.purchaseDate || '-' }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span class="grey--text">Hạn bảo hành:</span>
            <span class="ml-2 font-weight-medium" :class="{ 'red--text': isWarrantyExpired }">
              {{ item.warrantyExpiry || '-' }}
              <span v-if="isWarrantyExpired" class="text-caption font-weight-bold">(Hết hạn)</span>
            </span>
          </v-col>
        </v-row>

        <!-- Khối quy đổi đơn vị nếu có -->
        <div v-if="item.unitConversions && item.unitConversions.length" class="mb-4">
          <div class="text-subtitle-2 font-weight-bold mb-2">QUY ĐỔI ĐƠN VỊ TÍNH</div>
          <v-simple-table dense class="elevation-1">
            <template v-slot:default>
              <thead>
                <tr class="grey lighten-4">
                  <th>Đơn vị lớn</th>
                  <th class="text-center">Tỷ lệ quy đổi</th>
                  <th>Đơn vị cơ bản</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(conv, idx) in item.unitConversions" :key="idx">
                  <td><strong>1 {{ conv.unitName }}</strong></td>
                  <td class="text-center">= {{ conv.conversionRate }}</td>
                  <td>{{ item.unit || 'Chiếc' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <!-- Thông số kỹ thuật -->
        <div v-if="item.specifications" class="mb-3">
          <div class="text-subtitle-2 font-weight-bold mb-1">THÔNG SỐ KỸ THUẬT / CẤU HÌNH</div>
          <div class="pa-3 grey lighten-4 rounded text-body-2" style="white-space: pre-line;">
            {{ item.specifications }}
          </div>
        </div>

        <!-- Ghi chú -->
        <div v-if="item.note" class="mb-3">
          <div class="text-subtitle-2 font-weight-bold mb-1">GHI CHÚ</div>
          <div class="pa-3 grey lighten-4 rounded text-body-2" style="white-space: pre-line;">
            {{ item.note }}
          </div>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="dialog = false">Đóng</v-btn>
        <v-spacer />
        <v-btn color="indigo" dark depressed class="mr-2" @click="onOpenBarcode">
          <v-icon left small>mdi-qrcode</v-icon> Mã QR / Tem
        </v-btn>
        <v-btn color="primary" depressed @click="onOpenEdit">
          <v-icon left small>mdi-pencil</v-icon> Chỉnh sửa
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'AssetDetailDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    isWarrantyExpired() {
      if (!this.item || !this.item.warrantyExpiry) return false
      return new Date(this.item.warrantyExpiry) < new Date()
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    get,
    onOpenBarcode() {
      this.dialog = false
      this.$emit('open-barcode', this.item)
    },
    onOpenEdit() {
      this.dialog = false
      this.$emit('open-edit', this.item)
    }
  }
}
</script>
